<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'font-family',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Font Family',
            tailwindDefinitionProp: 'fontFamily',
            value: '',
        };
    },

    computed: {
        options() {
            return this.themeObjectValues.map(v => ({ value: v, text: v }));
        },
    },

    methods: {
        onInput(valueNew) {
            const flexClassNew = this.addFlexClass({
                value: valueNew,
            });

            this.value = valueNew;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            let { value } = this.flexClassDefinition;

            if (!value) {
                value = this.getComputedValue();

                if (value.includes(',')) {
                    value = value.slice(0, value.indexOf(','));
                }
            }

            if (this.themeObjectValues.includes(value)) {
                this.value = value;
            } else {
                this.value = '';
            }
        },
    },
};
</script>
